let handler = null;
export function setUiSoundHandler(next) {
    handler = next;
}
export function playUiSound(sound) {
    handler?.(sound);
}
//# sourceMappingURL=sound.js.map